import React from 'react';
import ProductList from '../components/Products/ProductList';
const Home = () => {
  return <ProductList />;
};
export default Home;
